export default __webpack_public_path__ + "static/media/Qnergy_Symbol_RGB.3dacf4c1.svg";